import { Fragment, useEffect, useState } from "react";
import {
	Box,
	Button,
	Container,
	Divider,
	IconButton,
	Tooltip,
	Typography,
	useMediaQuery,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../../context/Cart/CartContext.jsx";
import { useAuth } from "../../context/Auth/AuthContext.jsx";
import AddressShipping from "../../components/AddressShipping/AddressShipping.jsx";
import { api } from "../../services/api/index.js";
import REGEX from "../../utils/regex/regex.js";
import CarrierShipping from "../../components/CarrierShipping/CarrierShipping.jsx";

function AddressShippingContainer() {
	const [addressEdit, setAddressEdit] = useState(false);
	const [carrierEdit, setCarrierEdit] = useState(false);
	const [states, setStates] = useState([]);
	const [carriers, setCarriers] = useState();
	const [addresses, setAddresses] = useState();
	const [addressDataForm, setAddressDataForm] = useState([
		{
			id: "clientAddress",
			element: "input",
			type: "text",
			label: "Dirección",
			value: "",
			error: "",
			regEx: REGEX.lettersAndNumbersValidator,
			regMessage: "La dirección debe contener números y letras",
		},
		{
			id: "clientFloor",
			element: "input",
			type: "text",
			label: "Piso",
			value: "",
			error: "",
			regEx: REGEX.floorAndApartment,
			regMessage: "El piso debe contener solo números y letras",
		},
		{
			id: "clientDoor",
			element: "input",
			type: "text",
			label: "Departamento",
			value: "",
			error: "",
			regEx: REGEX.floorAndApartment,
			regMessage: "El departamento debe contener solo números y letras",
		},
		{
			id: "clientCity",
			element: "input",
			type: "text",
			label: "Ciudad",
			value: "",
			error: "",
			regEx: REGEX.textFormatValidator,
			regMessage: "La ciudad debe contener solo letras",
		},
		{
			id: "clientZipCode",
			element: "input",
			type: "text",
			label: "Código Postal",
			value: "",
			error: "",
			regEx: REGEX.zipCode,
			regMessage: "El código postal debe tener 4 o 5 números",
		},
		{
			id: "clientStateName",
			element: "select",
			type: "text",
			label: "Provincia",
			value: "",
			error: "",
			regEx: REGEX.textFormatValidator,
			regMessage: "Debe seleccionar una provincia",
		},
	]);
	const [carrierDataForm, setCarrierDataForm] = useState([
		{
			id: "clientTranspoName",
			element: "select",
			type: "text",
			label: "Transporte",
			value: "",
			error: "",
			regEx: REGEX.transpoValidator,
			regMessage: "Debe seleccionar un transporte",
		},
	]);
	const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
	const { userData, setUserData } = useAuth();
	const { cart } = useCart();
	const navigate = useNavigate();

	const toggleAddressEdit = () => {
		setAddressEdit((currentValue) => !currentValue);
	};

	const toggleCarrierEdit = () => {
		setCarrierEdit((currentValue) => !currentValue);
	};

	const handleChangeAddress = (evt) => {
		const newDataForm = [...addressDataForm];
		newDataForm.forEach((dato) => {
			if (evt.target.name === dato.id) dato.value = evt.target.value;
		});
		setAddressDataForm(newDataForm);
	};

	const handleChangeCarrier = (evt) => {
		const newDataForm = [...carrierDataForm];
		newDataForm.forEach((dato) => {
			if (evt.target.name === dato.id) dato.value = evt.target.value;
		});
		setCarrierDataForm(newDataForm);
	};

	const handleLocalDelete = (id) => {
		const addressesAux = addresses.filter(
			(address) => address.addressId !== id
		);
		setAddresses(addressesAux);
	};

	const dataValidation = (fn, data) => {
		let errorMessage = "";
		const newDataForm = [...data];
		newDataForm.forEach((field) => {
			field.error = !field.value.toString().match(field.regEx)
				? field.regMessage
				: "";
			errorMessage = errorMessage + field.error;
		});
		fn(newDataForm);

		return errorMessage;
	};

	const createUserData = (data) => {
		let formattedData = [];
		formattedData = data.map((el) => {
			return [...formattedData, el.id, el.value];
		});
		return Object.fromEntries(formattedData);
	};

	const saveUserDataAPI = (data) => {
		let error = "";

		const newUserData = createUserData(data);
		newUserData.clientAddressDescrp = "principal";
		newUserData.clientId = userData.clientId;
		newUserData.userId = userData.userId;

		if (data[0].id === "clientAddress") {
			api.account
				.updateUserAddress(newUserData)
				.then((data) => {
					if (data.status !== 200) {
						Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
								title: "swalTitle",
							},
							position: "left",
							icon: "error",
							title: "Húbo un error",
							text: "Intente nuevamente.",
							width: "350px",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#36A160",
							color: "#292929",
							background: "#FAFAFA",
							confirmButtonColor: "rgb(230, 11, 19)",
						});

						return;
					}
					if (data.status === 200) {
						Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
								title: "swalTitle",
							},
							position: "left",
							icon: "success",
							title: "Se han guardado sus datos",
							width: "350px",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#36A160",
							color: "#292929",
							background: "#FAFAFA",
							confirmButtonColor: "rgb(230, 11, 19)",
						});
					}
					setUserData({ ...userData, ...newUserData });
					toggleAddressEdit();
				})
				.catch((err) => (error = err));
		} else {
			newUserData.clientTranspoId = parseInt(
				carriers.find(
					(carrier) => carrier.name === newUserData.clientTranspoName
				)?.id
			);
			api.account
				.updateUserTransport(newUserData)
				.then((data) => {
					if (data.status !== 200) {
						Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
								title: "swalTitle",
							},
							position: "left",
							icon: "error",
							title: "Húbo un error",
							text: "Intente nuevamente.",
							width: "350px",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#36A160",
							color: "#292929",
							background: "#FAFAFA",
							confirmButtonColor: "rgb(230, 11, 19)",
						});

						return;
					}
					if (data.status === 200) {
						Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
								title: "swalTitle",
							},
							position: "left",
							icon: "success",
							title: "Se han guardado sus datos",
							// text: "Gracias por registrarte. Estamos validando la información registrada y serás notificado del alta a la brevedad.",
							width: "350px",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#36A160",
							color: "#292929",
							background: "#FAFAFA",
							confirmButtonColor: "rgb(230, 11, 19)",
						});
					}
					setUserData({ ...userData, ...newUserData });
					toggleCarrierEdit();
				})
				.catch((err) => (error = err));
		}
		return error;
	};

	const handleAddressSubmit = (e) => {
		e.preventDefault();
		let validatingError = "";
		validatingError = dataValidation(setAddressDataForm, addressDataForm);
		if (validatingError !== "") {
			return;
		}
		saveUserDataAPI(addressDataForm);
	};

	const handleCarrierSubmit = (e) => {
		e.preventDefault();
		let validatingError = "";
		validatingError = dataValidation(setCarrierDataForm, carrierDataForm);
		if (validatingError !== "") {
			return;
		}
		saveUserDataAPI(carrierDataForm);
	};

	useEffect(() => {
		if (addressDataForm.every((data) => data.value === "")) {
			addressDataForm.forEach((data) => {
				data.value = userData[data.id];
			});
		}

		const controller = new AbortController();

		api.account
			.getUserAddresses(userData)
			.then((response) => response.json())
			.catch((err) => console.log(err))
			.then((addressesAPI) => {
				addressesAPI.forEach(
					(address) =>
						(address.clientCity = address.clientCity.replace(/\d+/g, "").trim())
				);
				setAddresses(addressesAPI);
			})
			.catch((err) => console.log(err));

		api.utilities
			.getCarriers()
			.then((response) => response.json())
			.catch((err) => console.log(err))
			.then(setCarriers)
			.catch((err) => console.log(err));

		api.utilities
			.getStates(controller.signal)
			.then((res) => res.json())
			.catch((err) => console.log(err))
			.then(setStates)
			.catch((err) => console.log(err));

		window.scrollTo(0, 0);

		return () => {
			controller.abort();
		};
	}, [addressDataForm, userData]);

	return (
		<Fragment>
			<Container>
				<Box display="flex" alignItems="center" minHeight="56px">
					<Box>
						<Tooltip title="Volver">
							<IconButton
								size="large"
								aria-label="volver"
								aria-controls="volver-carrito"
								aria-haspopup="false"
								color="inherit"
								onClick={() => navigate(-1)}
							>
								<ArrowBackIosIcon />
							</IconButton>
						</Tooltip>
					</Box>
					<Typography
						variant="h5"
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexGrow={1}
					>
						Direcciones y envíos
					</Typography>
					<Box>
						<Tooltip title="Carrito">
							<Link to="/cart">
								<IconButton
									size="large"
									aria-label="carrito"
									aria-controls="logo-carrito"
									aria-haspopup="false"
									color="inherit"
								>
									{Boolean(cart?.length) ? (
										<ShoppingCartIcon color="secondary" />
									) : (
										<ShoppingCartOutlinedIcon color="secondary" />
									)}
								</IconButton>
							</Link>
						</Tooltip>
					</Box>
				</Box>
			</Container>

			<Divider />

			<Container sx={{ minHeight: "75vh" }}>
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="baseline"
				>
					<Box className="boxInfoContainer" my={1} pt={2}>
						<Typography className="titleFirstRow" sx={{ fontWeight: "600" }}>
							Direcciones de envío
						</Typography>
					</Box>
				</Box>
				<Divider />
				{userData.clientAddress || addressEdit ? (
					<Fragment>
						<AddressShipping
							userData={userData}
							addresses={addresses}
							dataForm={addressDataForm}
							handleChange={handleChangeAddress}
							handleSubmit={handleAddressSubmit}
							handleLocalDelete={handleLocalDelete}
							states={states}
							carriers={carriers}
							toggleEdit={toggleAddressEdit}
							edit={addressEdit}
						/>
					</Fragment>
				) : (
					<Container>
						<Box
							sx={{
								minHeight: "20vh",
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Typography
								variant="h3	"
								sx={{ color: "#5E5E5E", textAlign: "center" }}
							>
								No tiene direcciones de envío asociadas a su cuenta
							</Typography>
							<Button
								variant="contained"
								color="secondary"
								size={isSmallScreen ? "small" : "medium"}
								sx={{ marginTop: "1rem" }}
								onClick={toggleAddressEdit}
							>
								Agregar
							</Button>
						</Box>
					</Container>
				)}
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="baseline"
				>
					<Box className="boxInfoContainer" my={1} pt={2}>
						<Typography className="titleFirstRow" sx={{ fontWeight: "600" }}>
							Método de envío
						</Typography>
					</Box>
				</Box>
				<Divider />
				{userData.clientTranspoId || carrierEdit ? (
					<CarrierShipping
						userData={userData}
						carrierDataForm={carrierDataForm}
						carriers={carriers}
						handleChange={handleChangeCarrier}
						handleSubmit={handleCarrierSubmit}
						edit={carrierEdit}
						toggleEdit={toggleCarrierEdit}
					/>
				) : (
					<Container>
						<Box
							sx={{
								minHeight: "20vh",
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Typography
								variant="h3	"
								sx={{ color: "#5E5E5E", textAlign: "center" }}
							>
								No tiene transporte asociado a su cuenta
							</Typography>
							<Button
								variant="contained"
								color="secondary"
								size={isSmallScreen ? "small" : "medium"}
								sx={{ marginTop: "1rem" }}
								onClick={toggleCarrierEdit}
							>
								Agregar
							</Button>
						</Box>
					</Container>
				)}
			</Container>
		</Fragment>
	);
}

export default AddressShippingContainer;
